// ToDo : Delete all these
export const API_URL = "http://15.206.90.118";
export const API_URL_NEW = "http://20.204.99.63:8004";
export const API_ERROR_500 = "internal server error!";

const Testing = "https://testcentral.betasec.in";
const Development = "https://ekycsited.compliancesutra.com/";
// const Development = "https://betasec.in";

export const getCentralURL = () => {
  return Development;
};
